import { faker } from '@faker-js/faker'

import { getUserTreatment } from './UserTreatment'

import { UserTreatmentCategory } from '../../contracts/treatment'
import { SupernovaResponse } from '../../foundation'
import { asBuilder } from '../asBuilder'

export const getUserTreatmentCategories = asBuilder<SupernovaResponse<UserTreatmentCategory[]>>(
  (): SupernovaResponse<UserTreatmentCategory[]> => {
    return {
      timestamp: new Date().toISOString(),
      status: 200,
      message: 'success',
      body: faker.helpers.multiple(
        () => ({
          ...getUserTreatment(),
          label: faker.lorem.word() + faker.lorem.paragraph(),
        }),
        { count: faker.number.int({ min: 2, max: 10 }) },
      ),
    }
  },
)
